import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPackagePaymentTransactionMutationVariables = GraphQLTypes.Exact<{
  paymentId: GraphQLTypes.Scalars['String'];
  transaction: GraphQLTypes.TransactionInput;
}>;


export type AddPackagePaymentTransactionMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'addPackagePaymentTransaction'>
);


export const AddPackagePaymentTransactionDocument = /*#__PURE__*/ gql`
    mutation addPackagePaymentTransaction($paymentId: String!, $transaction: TransactionInput!) {
  addPackagePaymentTransaction(paymentId: $paymentId, transaction: $transaction)
}
    `;

/**
 * __useAddPackagePaymentTransactionMutation__
 *
 * To run a mutation, you first call `useAddPackagePaymentTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackagePaymentTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackagePaymentTransactionMutation, { data, loading, error }] = useAddPackagePaymentTransactionMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      transaction: // value for 'transaction'
 *   },
 * });
 */
export function useAddPackagePaymentTransactionMutation(baseOptions?: Apollo.MutationHookOptions<AddPackagePaymentTransactionMutationResult, AddPackagePaymentTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackagePaymentTransactionMutationResult, AddPackagePaymentTransactionMutationVariables>(AddPackagePaymentTransactionDocument, options);
      }
export type AddPackagePaymentTransactionMutationHookResult = ReturnType<typeof useAddPackagePaymentTransactionMutation>;